export enum AggregationType {
  WEIGHTED_AVERAGE = 'WE',
  SUM = 'LS',
  NO_AGG = 'NA',
  ASYNC = 'AS',
  PERCENT_DELTA = 'PD'
}
